<template>
  <div id="List" class="sun">
    <ProfileModal @complete="complete" @close="isProfileModal=false" v-if="isProfileModal"/>
    <div class="scroll">
      <div
        v-infinite-scroll="loadPageItems"
        infinite-scroll-disabled="isLoading"
        infinite-scroll-distance="0"
        infinite-scroll-immediate-check="false"
        infinite-scroll-throttle-delay="1000"
      >
        <QuestionList v-if="questions.length>=1"
                      :fixedQuestion="fixedQuestion"
                      :questions="questions" />
                      <!-- @editQuestion="editQuestion"
                      @removeQuestion="removeQuestion" -->
      </div>
    </div>
    <TalkInput @createQuestion="createQuestion"/>
  </div>
</template>

<script>
import QuestionList from './components/QuestionList'
import TalkInput from './components/TalkInput'
import ProfileModal from './components/ProfileModal'

// Services
import AuthService from '@/service/auth/AuthService'
import { sleep } from '@/util'

import talksApi from '@/api/now/talksApi'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    ProfileModal,
    QuestionList,
    TalkInput,
  },
  computed: {
    ...mapGetters('talks', {
      questions: 'getTalks',
      paging: 'getPaging',
      beforeTalk: 'getBeforeTalk',
    }),
  },
  data() {
    return {
      fixedQuestion: null,
      isLoading: false,
      isProfileModal: false
    }
  },
  async created() {
    // Set isProfileModal
    this.setIsProfileModal()

    this.getFixedQuestion()

    // 상세 페이지에서 들어오는 게 아니면 beforeEnter 에서 목록 비우고 들어옴
    if (this.questions.length < 1) {
      // 목록 없는 경우
      this.loadPageItems()
    } else if (this.beforeTalk != null && this.questions.some(question => question.uuid === this.beforeTalk.uuid)) {
      // 목록 있으면서 목록 안에 방금 본 게시글이 포함되어있는 경우 스크롤

      // 방금 본 게시글이 수정됐을 경우 대비 다시 조회
      const { data } = await talksApi.getQuestion(this.beforeTalk.uuid)
      this.updateItem(data)

      // 방금 본 게시글로 스크롤 이동
      await this.scrollToTalk(this.beforeTalk)

      // 방금 본 게시글 기록 초기화
      this.clearItem()
    } else {
      this.clear()
      this.loadPageItems()
    }
  },
  methods: {
    setIsProfileModal() {
      let user = AuthService.getProfile()
      if (!user.category || !user.startdate || !user.nickname || !user.image_nowtalk) {
        setTimeout(() => {
          this.isProfileModal = true
        }, 3000)
      }
    },
    complete() {
      this.isProfileModal = false
    },
    async scrollToTalk(talk, option) {
      // nextTick 걸어도 vuetify.goTo에서 not found 에러나는 경우 있음
      await this.$nextTick(async _ => {
        await sleep(100)
        const elementId = `Question-${talk.uuid}`
        const element = document.getElementById(elementId)
        if (element) {
          this.$vuetify.goTo(`#${elementId}`, option)
        }
      })
    },
    async getFixedQuestion() {
      // 상단 고정 게시글 조회
      const { data: { results } } = await talksApi.getFixedQuestion()
      if (results && results.length >= 1) {
        this.fixedQuestion = results
      }
    },
    async loadPageItems() {
      // 다음 페이지 데이터 조회
      if (this.isLoading || this.paging.isLastPage) {
        return
      }
      try {
        this.isLoading = true
        const page = this.paging.page ? this.paging.page + 1 : 1
        const { data } = await talksApi.getQuestions({ page })
        this.loadPage({
          data, page
        })
        if (this.paging.isLimited) {
          await this.scrollToTalk(data.results[0], { offset: 600 })
        }
      } finally {
        this.isLoading = false
      }
    },
    async createQuestion(question) {
      this.clear()
      await this.loadPageItems()
      this.scrollToTalk(question)
    },
    ...mapActions('talks', ['loadPage', 'clear', 'updateItem', 'clearItem'])
  },
}
</script>

<style>
  .custom-recommendation-dialog {
    margin: 0;
  }
</style>
<style lang="scss" scoped>
  #List {
    width: 100%;
    max-width: inherit;
    min-height: calc(100vh - 60px);
    background-color: #f6f6f6;
    padding-bottom: 150px;
  }
</style>
